import { Icon } from "materia"
import s from "./YourJourneysList.module.scss"

export const CompletedCheck = () => (
  <div className={s.completedCheck} aria-hidden>
    <Icon icon="Checkmark" size="small" />
  </div>
)
